var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolana(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60096 15.6866C6.69907 15.577 6.8309 15.5154 6.96886 15.5154H19.7383C19.9713 15.5154 20.0878 15.8303 19.9223 16.0117L17.399 18.8288C17.3009 18.9384 17.1691 19 17.0311 19H4.26168C4.02867 19 3.91217 18.6851 4.07772 18.5037L6.60096 15.6866Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60096 5.17115C6.69907 5.06161 6.8309 5 6.96886 5H19.7383C19.9713 5 20.0878 5.31491 19.9223 5.49633L17.399 8.31002C17.3009 8.41956 17.1691 8.48117 17.0311 8.48117H4.26168C4.02867 8.48117 3.91217 8.16625 4.07772 7.98484L6.60096 5.17115Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.399 10.3946C17.3009 10.2851 17.1691 10.2234 17.0311 10.2234H4.26168C4.02867 10.2234 3.91217 10.5384 4.07772 10.7198L6.60096 13.5335C6.69907 13.643 6.8309 13.7046 6.96886 13.7046H19.7383C19.9713 13.7046 20.0878 13.3897 19.9223 13.2083L17.399 10.3946Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana);
export default __webpack_public_path__ + "static/media/solana.4727ea2251c33cdfbdb9a764f21ae609.svg";
export { ForwardRef as ReactComponent };